var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.938,
    height: 78.057,
    viewBox: "0 0 78.938 78.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_1737",
    x: 0,
    y: 0,
    width: 78.938,
    height: 78.057,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boton-whatsapp",
    transform: "translate(-1148.364 -614.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_648",
    "data-name": "Grupo 648",
    transform: "translate(-2125.636 -189.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M11.533,47.839l-9.867,2.48,2.593-9.854A25.721,25.721,0,0,1,0,26.269C0,11.761,12.035,0,26.881,0S53.762,11.761,53.762,26.269s-12.035,26.27-26.881,26.27A27.188,27.188,0,0,1,11.533,47.839Z",
    transform: "translate(3286.545 813.57)",
    fill: "#31b121"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3274, 804)",
    filter: "url(#Trazado_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1737-2",
    "data-name": "Trazado 1737",
    d: "M54.075,10.613A30.463,30.463,0,0,0,32.583,1.89C15.846,1.89,2.228,15.236,2.228,31.639A29.187,29.187,0,0,0,6.3,46.513L2,61.947l16.09-4.138a30.667,30.667,0,0,0,14.493,3.616h0c16.737,0,30.355-13.346,30.355-29.749A29.126,29.126,0,0,0,54.075,10.613ZM32.621,56.392h0a25.791,25.791,0,0,1-12.857-3.43l-.913-.522L9.3,54.864l2.549-9.133-.609-.932A24.505,24.505,0,0,1,7.4,31.639C7.4,17.995,18.737,6.923,32.659,6.923A25.229,25.229,0,0,1,50.5,14.192a24.344,24.344,0,0,1,7.38,17.484A25.037,25.037,0,0,1,32.621,56.392ZM46.467,37.9c-.761-.373-4.489-2.162-5.173-2.423s-1.217-.373-1.712.373-1.978,2.423-2.4,2.908c-.456.485-.875.559-1.636.186a20.677,20.677,0,0,1-6.086-3.691A22.71,22.71,0,0,1,25.2,30.11c-.456-.746-.038-1.156.342-1.528.342-.336.761-.857,1.141-1.3a6,6,0,0,0,.761-1.23,1.316,1.316,0,0,0-.076-1.3c-.19-.373-1.712-4.026-2.32-5.517-.647-1.454-1.255-1.267-1.712-1.3H21.856a2.8,2.8,0,0,0-2.016.932,8.283,8.283,0,0,0-2.663,6.188c0,3.653,2.7,7.195,3.081,7.68s5.363,8.015,12.971,11.221a39.707,39.707,0,0,0,4.336,1.566,10.833,10.833,0,0,0,4.793.3c1.445-.224,4.489-1.789,5.135-3.542a6.049,6.049,0,0,0,.456-3.542A4.107,4.107,0,0,0,46.467,37.9Z",
    transform: "translate(7 4.11)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonWhatsapp);
export default __webpack_public_path__ + "static/media/boton-whatsapp.5a5b4b0791c468c38f7689e65c20f6b6.svg";
export { ForwardRef as ReactComponent };